import { IonButtons, IonToolbar } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';
import styles from './MobileHeader.module.css';

type Props = {
  name?: string;
};

const MobileHeader: React.FC<Props> = ({ name }) => {
  const { t } = useTranslation();

  const title = {
    'wallet-page': t('general.wallet'),
    'invest-page': t('general.invest'),
    'settings-page': t('settings.title')
  }[name || ''];

  return (
    <IonToolbar no-border className={styles.headerContainer}>
      <h1 slot="start" className={styles.title}>
        {title}
      </h1>
      <IonButtons slot="end">
        <UserProfileMenu />
      </IonButtons>
    </IonToolbar>
  );
};

export default MobileHeader;
